import './audit-log.scss'

import React from 'react'

import { Column, Summary, TotalItem } from 'devextreme-react/data-grid'
import Form from 'devextreme-react/form'
import { Item } from 'devextreme-react/select-box'
import { formatMessage } from 'devextreme/localization'
import * as FileSaver from 'file-saver'
import 'jspdf-autotable'
import moment from 'moment'
import Cookies from 'universal-cookie'
import * as XLSX from 'xlsx'

import { GetUserLayout } from '../../../api/user-preferred-layout'
import { DataGridDefault, customSearch } from '../../../components/index'
import Flash from '../../../components/message/flash'
import DownloadPopUp from '../../../components/pop-up/download-popup'
import ErrorPopUp from '../../../components/pop-up/error-popup'
import { ListingHeader6 } from '../../../layouts/index'
import {
  AdminYN,
  ClientID,
  CompanyID,
  DefaultName,
  SetCompanyID,
  SetDecimalPoints,
  SetDefaultName,
  Token,
  UserID,
} from '../../../utils/default-cookies'
import { DefaultPager } from '../../../utils/default-data-grid-settings'
import { DefaultSMIAuditLog } from '../../../utils/default-smi'
import {
  authenticateEmbeddedMessage,
  requestEmbeddedAuth,
} from '../../../utils/embedded-auth'
import { GetUserGroupAccessRightsByModuleItem } from '../package-item/package-item-services'
import {
  GetAllCompaniesIAGByUser,
  GetAllDocumentType,
  GetAllSetting,
  GetAllUser,
  GetAuditLogSetting,
  GetAuditLogSettingCount,
} from './audit-log-service'

const cookies = new Cookies()

const DATE_FORMATS = {
  '{dd}/{MM}/{yyyy}': 'DD/MM/YYYY',
  '{dd}/{yyyy}/{MM}': 'DD/YYYY/MM',
  '{MM}/{dd}/{yyyy}': 'MM/DD/YYYY',
  '{MM}/{yyyy}/{dd}': 'MM/YYYY/DD',
  '{yyyy}/{dd}/{MM}': 'YYYY/DD/MM',
  '{yyyy}/{MM}/{dd}': 'YYYY/MM/DD',
}

const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY'
const AUDIT_LOG_DOWNLOAD_THRESHOLD = 500
const AUDIT_LOG_DEFAULT_SMI = {
  ...DefaultSMIAuditLog,
  moduleURL: DefaultSMIAuditLog.auditLog,
}

class AuditLog extends React.Component {
  constructor(props) {
    super(props)

    //component instance
    this.dataGridRef = React.createRef()
    this.childToolBarRef = React.createRef()
    this.childHeader = React.createRef()

    this.searchValueChangeHandler = this.searchValueChangeHandler.bind(this)
    this.selectValueChangeHandler = this.selectValueChangeHandler.bind(this)
    this.onFilterClick = this.onFilterClick.bind(this)
    this.applyAuditLogFilter = this.applyAuditLogFilter.bind(this)
    this.getAuditLogCount = this.getAuditLogCount.bind(this)
    this.onSelectDateCallBack = this.onSelectDateCallBack.bind(this)
    this.setTagBoxValue = this.setTagBoxValue.bind(this)
    this.onSelectUserIDCallBack = this.onSelectUserIDCallBack.bind(this)
    this.onFocusedRowChanged = this.onFocusedRowChanged.bind(this)
    this.onValueChange = this.onValueChange.bind(this)

    this.onCellPrepared = this.onCellPrepared.bind(this)
    this.onFlashMessageTimer = this.onFlashMessageTimer.bind(this)
    this.closeFlashMessageCallback = this.closeFlashMessageCallback.bind(this)
    this.filterBySearchText = this.filterBySearchText.bind(this)

    this.handleDownloadConfirmationDialog =
      this.handleDownloadConfirmationDialog.bind(this)
    this.handleDownloadPopUpCallBack =
      this.handleDownloadPopUpCallBack.bind(this)
    this.handleSessionPopUpCallBack = this.handleSessionPopUpCallBack.bind(this)
    this.detectPressKey = this.detectPressKey.bind(this)

    this.showMsgHandler = this.showMsgHandler.bind(this)
    this.showInfoChange = this.showInfoChange.bind(this)

    this.GetFormattedDate = this.GetFormattedDate.bind(this)
    this.receiveMessage = this.receiveMessage.bind(this)
    this.fetchDataAPI = this.fetchDataAPI.bind(this)
    this.handlePreferedLayout = this.handlePreferedLayout.bind(this)
    this.shouldResetSavedLayout = this.shouldResetSavedLayout.bind(this)

    this.state = {
      companies: [],
      selectedUserID: [],
      defaultDateFormat: '',
      userID: [],
      defaultUsername: [],
      parentItemCode: null,
      auditLogSetting: [],
      docType: [],
      allSetting: [],
      searchText: '',
      allowSave: false,
      allowDelete: false,
      allowCopy: false,
      allowAdd: false,
      viewDtl: false,
      buttonMode: true,
      displayFlashMessageDialog: false,
      status: 'success',
      size: 'flash-message-success-container',
      fromDate: '',
      toDate: '',
      allowExportGrid: false,
      allowDisplayColumnChooser: false,
      allowRestoreLayout: false,
      allowSaveLayout: false,
      preferedLayout: [],
      displayDownloadPopUp: false,
      displaySessionPopUp: false,
      isDeleteBtnFocus: true,
      noDataText: formatMessage('Loading'),
    }

    this.defaultDateFormat = DEFAULT_DATE_FORMAT
  }

  closeFlashMessageCallback = () => {
    this.setState((state) => ({
      displayFlashMessageDialog: !state.displayFlashMessageDialog,
    }))
  }

  showInfoChange(value) {
    this.setState({ ...this.state, showInfo: value })
  }

  handleSessionPopUpCallBack = () => {
    this.setState((state) => ({
      displaySessionPopUp: !state.displaySessionPopUp,
    }))
  }

  handleDownloadPopUpCallBack = () => {
    this.getAuditLogExcel()
  }

  //get audit log excel data
  async getAuditLogExcel() {
    var auditLogList = await Promise.all([
      GetAuditLogSetting(
        Token(),
        CompanyID(),
        this.state.selectedUserID,
        this.state.parentItemCode,
        this.state.fromDate,
        this.state.toDate,
      ),
    ])
    var result = auditLogList[0]

    for (var i = 0; i < result.length; i++) {
      result[i].LogDatetime = this.formatDateTime(result[i].LogDatetime)
    }

    const newArray = result.map((item) => {
      return {
        'Date & Time': item.LogDatetime,
        Code: item.Code,
        'Event Type': item.EventType,
        'Column Name': item.ColumnName,
        Description: item.Description,
        'User ID': item.UserID,
      }
    })

    this.exportGridXLSX(newArray, 'Package-Item')
    this.handleDownloadConfirmationDialog()
  }

  //get audit log list
  async getAuditLogList() {
    this.setState({ noDataText: formatMessage('Loading') })

    var result = await GetAuditLogSetting(
      Token(),
      CompanyID(),
      this.state.selectedUserID,
      this.state.parentItemCode,
      this.state.fromDate,
      this.state.toDate,
    )

    if (result === 'Error: 401') {
      this.handleSessionPopUpCallBack()
      this.setState({ noDataText: formatMessage('dxDataGrid-noDataText') })
      return
    }

    for (var i = 0; i < result.length; i++) {
      result[i].LogDatetime = this.formatDateTime(result[i].LogDatetime)
    }

    this.setState(
      {
        auditLogSetting: result,
        noDataText: formatMessage('dxDataGrid-noDataText'),
      },
      this.filterBySearchText,
    )
  }

  exportGridXLSX = (csvData, fileName) => {
    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    const fileExtension = '.xlsx'
    var today = new Date()

    const ws = XLSX.utils.json_to_sheet(csvData)
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
    const data = new Blob([excelBuffer], { type: fileType })
    FileSaver.saveAs(
      data,
      fileName +
        '-' +
        today.getFullYear() +
        '-' +
        (today.getMonth() + 1) +
        '-' +
        today.getDate() +
        fileExtension,
    )
  }

  handleDownloadConfirmationDialog = () => {
    this.setState((state) => ({
      displayDownloadPopUp: !state.displayDownloadPopUp,
    }))
  }

  handleCompanies = (result) => {
    this.setState({ companies: result })
  }

  handleUserID = (result) => {
    var name = []

    var data = result.find((x) => x.US_ID == UserID())
    name.push(data.US_UserID)
    this.defaultDateFormat = data.US_DateFormat || DEFAULT_DATE_FORMAT

    this.setState({
      userID: result,
      defaultUsername: name,
      defaultDateFormat: this.defaultDateFormat,
    })
  }

  handleAuditLogSetting = (result) => {
    if (result === 'Error: 401') {
      this.handleSessionPopUpCallBack()
      this.setState({ noDataText: formatMessage('dxDataGrid-noDataText') })
      return
    }

    if (result.Total > AUDIT_LOG_DOWNLOAD_THRESHOLD) {
      this.setState({ noDataText: formatMessage('dxDataGrid-noDataText') })
      this.handleDownloadConfirmationDialog()
    } else {
      this.getAuditLogList()
    }
  }

  handleAllowRestoreLayout = (result) => {
    this.setState({ allowRestoreLayout: result })
  }

  handleAllowSaveLayout = (result) => {
    this.setState({ allowSaveLayout: result })
  }

  handleAllowExportGrid = (result) => {
    this.setState({ allowExportGrid: result })
  }

  handleAllowDisplayColumnChooser = (result) => {
    this.setState({ allowDisplayColumnChooser: result })
  }

  handlePreferedLayout = (result) => {
    this.setState({ preferedLayout: result })
  }

  shouldResetSavedLayout(layout) {
    // Reset legacy saved layouts without stable names.
    // 'auditLogLogDatetime' is used as the version marker.
    const columns = layout?.columns || []
    const hasNamedLogDatetimeColumn = columns.some(
      (column) => column.name === 'auditLogLogDatetime_v1',
    )

    return !hasNamedLogDatetimeColumn
  }

  detectPressKey(event) {
    if (event.keyCode === 9) {
      this.setState((state) => ({
        isDeleteBtnFocus: !state.isDeleteBtnFocus,
      }))
    }
  }

  formatDateTime = (result) => {
    const date = moment(result)

    if (!date.isValid()) return result

    const dateFormat =
      DATE_FORMATS[this.state.defaultDateFormat] ||
      DATE_FORMATS[this.defaultDateFormat] ||
      DEFAULT_DATE_FORMAT

    return date.format(`${dateFormat} HH:mm`)
  }

  handleDocType = (result) => {
    this.setState({ docType: result })
  }

  handleAllSetting = (result) => {
    this.setState({ allSetting: result })
  }

  geturlInfo(e) {
    const location = e?.currentTarget?.location?.href || window.location.href
    var parentInfo = new URL(location.replace('#', '')).searchParams

    var parentItemCode = parentInfo.get('id')?.trim() ?? null
    var parentCompanyID = parentInfo.get('companyID')

    if (parentCompanyID != null) {
      SetCompanyID(cookies, parentCompanyID)
    }

    var today = this.GetFormattedDate(new Date()) + 'T23:59:00'

    var default7Days = new Date()
    default7Days.setDate(default7Days.getDate() - 7)
    default7Days = this.GetFormattedDate(default7Days) + 'T00:00:00'

    this.setState({
      fromDate: default7Days,
      toDate: today,
      selectedUserID: UserID(),
      parentItemCode: parentItemCode,
    })

    return parentItemCode
  }

  componentDidMount() {
    window.addEventListener('message', this.receiveMessage, false)
    document.addEventListener('keydown', this.onFlashMessageTimer, false)
    document.addEventListener('keydown', this.detectPressKey, false)
    document.addEventListener('mousedown', this.onFlashMessageTimer, false)

    if (Token()) {
      const parentItemCode = this.geturlInfo()
      this.fetchDataAPI(parentItemCode)
    } else {
      // prompt Alaya 1.0 to re-postMessage for session data after receiveMessage eventListener is registered
      // to handle issue where initial postMessage is sent before eventListener is registered (iOS and macOS)
      requestEmbeddedAuth()
    }
  }

  componentWillUnmount() {
    //remove event listener
    window.removeEventListener('message', this.receiveMessage, false)
    document.removeEventListener('keydown', this.onFlashMessageTimer, false)
    document.removeEventListener('keydown', this.detectPressKey, false)
    document.removeEventListener('mousedown', this.onFlashMessageTimer, false)
  }

  async receiveMessage(event) {
    await authenticateEmbeddedMessage(event, cookies, {
      onAuthenticated: () => {
        const parentItemCode = this.geturlInfo(event)
        this.fetchDataAPI(parentItemCode)
      },
    })
  }

  async fetchDataAPI(parentItemCode = this.state.parentItemCode) {
    const [
      dataSource_GetAllCompanyIAG,
      dataSource_User,
      auditLogSetting_Count,
      dataSource_DocType,
      dataSource_AllSetting,
      UserPreferedLayout,
      UserAccessControl,
    ] = await Promise.all([
      GetAllCompaniesIAGByUser(Token(), ClientID(), UserID(), AdminYN()),
      GetAllUser(Token(), UserID()),
      GetAuditLogSettingCount(
        Token(),
        CompanyID(),
        UserID(),
        parentItemCode,
        this.state.fromDate,
        this.state.toDate,
      ),
      GetAllDocumentType(Token()),
      GetAllSetting(Token()),
      GetUserLayout(
        Token(),
        UserID(),
        DefaultSMIAuditLog.auditLog,
        DefaultSMIAuditLog.controlID,
      ),
      GetUserGroupAccessRightsByModuleItem(
        Token(),
        UserID(),
        DefaultSMIAuditLog.auditLog,
        CompanyID(),
      ),
    ])

    if (
      dataSource_GetAllCompanyIAG == 'Error: 401' ||
      dataSource_User == 'Error: 401' ||
      UserPreferedLayout == 'Error: 401' ||
      UserAccessControl == 'Error: 401'
    ) {
      this.handleSessionPopUpCallBack()
    } else {
      var currentCompanyData = dataSource_GetAllCompanyIAG.find(
        (x) => x.CO_ID == CompanyID(),
      )
      SetDefaultName(cookies, currentCompanyData.CO_Name)
      SetDecimalPoints(cookies, currentCompanyData.IAG_ItemRounding)

      this.handleCompanies(dataSource_GetAllCompanyIAG)
      this.handleUserID(dataSource_User)
      this.handleAuditLogSetting(auditLogSetting_Count)
      this.handleDocType(dataSource_DocType)
      this.handleAllSetting(dataSource_AllSetting)
      this.handlePreferedLayout(UserPreferedLayout)

      if (AdminYN() == 'true') {
        this.handleAllowDisplayColumnChooser(true)
        this.handleAllowExportGrid(true)
        this.handleAllowRestoreLayout(true)
        this.handleAllowSaveLayout(true)
      } else {
        this.handleAllowDisplayColumnChooser(
          UserAccessControl.Query_UserModuleItemAccessSimplified[0]
            .GridColumnChooser,
        )
        this.handleAllowExportGrid(
          UserAccessControl.Query_UserModuleItemAccessSimplified[0].ExportGrid,
        )
        this.handleAllowRestoreLayout(
          UserAccessControl.Query_UserModuleItemAccessSimplified[0]
            .RestoreGridLayout,
        )
        this.handleAllowSaveLayout(
          UserAccessControl.Query_UserModuleItemAccessSimplified[0]
            .SaveGridLayout,
        )
      }
    }
  }

  searchValueChangeHandler = (event) => {
    this.setState({ searchText: event }, this.filterBySearchText)
  }

  selectValueChangeHandler = (event) => {
    SetCompanyID(cookies, event)
  }

  onSelectUserIDCallBack = (value) => {
    var valueString = JSON.stringify(value).replace(/]|[[]/g, '')

    this.setState({ selectedUserID: valueString })
  }

  onValueChange = (value) => {
    this.setState({ parentItemCode: String(value ?? '').trim() })
  }

  onSelectDateCallBack = (fromDate, toDate) => {
    this.setState({
      fromDate: fromDate,
      toDate: toDate,
    })
  }

  setTagBoxValue = (value) => {
    this.setState({ defaultUsername: value })
  }

  GetFormattedDate(date) {
    var month = ('0' + (date.getMonth() + 1)).slice(-2)
    var day = ('0' + date.getDate()).slice(-2)
    var year = date.getFullYear()
    return year + '-' + month + '-' + day
  }

  hasRequiredFilterValues() {
    return (
      String(this.state.fromDate || '').trim() !== '' &&
      String(this.state.toDate || '').trim() !== '' &&
      String(this.state.selectedUserID || '').trim() !== '' &&
      String(this.state.parentItemCode || '').trim() !== ''
    )
  }

  getAuditLogCount() {
    return GetAuditLogSettingCount(
      Token(),
      CompanyID(),
      this.state.selectedUserID,
      this.state.parentItemCode,
      this.state.fromDate,
      this.state.toDate,
    )
  }

  onFilterClick = () => {
    this.applyAuditLogFilter()
  }

  async applyAuditLogFilter() {
    if (!this.hasRequiredFilterValues()) return

    const auditLogCount = await this.getAuditLogCount()
    this.handleAuditLogSetting(auditLogCount)
  }

  onFocusedRowChanged(e) {
    const dataRow = e.row && e.row.data
    //this.setState({ auditLogSetting: dataRow });
  }

  onFlashMessageTimer() {
    if (this.state.displayFlashMessageDialog === true) {
      setTimeout(
        () => this.setState({ displayFlashMessageDialog: false }),
        1000,
      )
    }
  }

  get dataGrid() {
    // `current.instance` points to the UI component instance
    return this.dataGridRef.current.instance
  }

  showMsgHandler(params, value, size) {
    if (params !== '') {
      this.setState({
        emptyMsg: params,
        displayFlashMessageDialog: true,
        status: value,
        size: size,
      })
    } else {
      this.setState({
        emptyMsg: '',
        displayFlashMessageDialog: false,
        status: value,
        size: size,
      })
    }
  }

  onCellPrepared(e) {
    if (e.rowType === 'totalFooter') {
      if (e.column.type === 'buttons') {
        const summaryValue = e.component.getTotalSummaryValue('totalCount')
        // create the required HTML element with 'summaryValue' and append it to 'e.cellElement'
        const span = document.createElement('span')
        span.className = 'dx-datagrid-summary-item'
        span.innerHTML = formatMessage('Records') + ': ' + summaryValue
        e.cellElement.appendChild(span)
      }
      if (e.column.dataField === 'A') {
        e.cellElement.innerHTML = ''
      }
    }
    if (e.rowType === 'totalAmount' && e.summaryItems.length) {
      e.cellElement.innerText =
        'Sum for ' + e.data.key + ': $' + e.summaryItems[0].value
    }
  }

  onOptionChanged = (e) => {
    if (e.fullName === 'columns[0].sortOrder') {
      e.component.option('focusedRowEnabled', false)
      e.component.option('focusedRowIndex', null)
    }
  }

  onContentReady = (e) => {
    e.component.option('focusedRowEnabled', true)
    e.component.option('focusedRowKey', e.component.getKeyByRowIndex(0))
    e.component.option('focusedRowIndex', 0)
  }

  filterBySearchText() {
    if (!this.dataGridRef.current) return

    const query = this.state.searchText.trim()

    if (query.length === 0) {
      const getValue = () => true
      this.dataGrid.filter([getValue, '=', true])
      this.dataGrid.option('navigateToFirst', true)
      return
    }

    const regExpText = '('.concat(
      query
        .replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&')
        .split(' ')
        .filter((el) => el.length > 0)
        .join(')|(')
        .concat(')'),
    )

    const regExp = new RegExp(regExpText, 'i')

    const searchableColumns = this.dataGrid
      .getVisibleColumns()
      .filter((column) => column.hasCustomSearch)
      .map((column) => column.dataField)

    const getValue = (row) =>
      searchableColumns.some((dataField) =>
        regExp.test(String(row[dataField] ?? '')),
      )

    this.dataGrid.filter([getValue, '=', true])
    this.dataGrid.option('navigateToFirst', true)
  }
  //#endregion

  render() {
    return (
      <React.Fragment>
        <div className="audit-log-navbar">
          <Flash
            parentCallback={this.closeFlashMessageCallback}
            message={this.state.emptyMsg}
            visible={this.state.displayFlashMessageDialog}
            severity={this.state.status}
            container={this.state.size}
          />

          <ErrorPopUp
            parentCallback={this.handleSessionPopUpCallBack}
            visible={this.state.displaySessionPopUp}
            title={formatMessage('SessionExpired')}
            subTitle={formatMessage('PleaseLoginAgain')}
          />

          <DownloadPopUp
            parentCallback={this.handleDownloadPopUpCallBack}
            hideDownloadPopup={this.handleDownloadConfirmationDialog}
            isDeleteBtnFocus={this.state.isDeleteBtnFocus}
            visible={this.state.displayDownloadPopUp}
          />
        </div>

        <Form id={'audit-log-form'} width={'100%'} colCount={8}>
          <Item colSpan={8}>
            <div className="package-item-header-title">
              <ListingHeader6
                placeHolderText={formatMessage('SearchPlaceholderText')}
                buttonText={formatMessage('Search')}
                companyCaption={formatMessage('Company')}
                dateRangeCaption={formatMessage('DateRange')}
                userIDCaption={formatMessage('UserID')}
                docTypeCaption={formatMessage('DocumentType')}
                docNoCaption={'Document No.'}
                settingCaption={formatMessage('Settings')}
                codeCaption={formatMessage('Code')}
                filterText={formatMessage('Filter')}
                displayDocColumn={false}
                dataSource_Companies={this.state.companies}
                dataSource_UserID={this.state.userID}
                dataSource_DocType={this.state.docType}
                defaultUsername={this.state.defaultUsername}
                parentItemCode={this.state.parentItemCode}
                dataSource_AllSetting={this.state.allSetting}
                buttonMode={this.state.buttonMode}
                defaultValue={CompanyID()}
                defaultName={DefaultName()}
                codeProp={'CO_Code'}
                nameProp={'CO_Name'}
                valueProp={'CO_ID'}
                displayProp={'IAG_Description'}
                defaultDateFormat={this.state.defaultDateFormat}
                onSearchValueChange={this.searchValueChangeHandler}
                onSelectValueChange={this.selectValueChangeHandler}
                filterDisabled={!this.hasRequiredFilterValues()}
                onFilterClick={this.onFilterClick}
                onSelectDateCallBack={this.onSelectDateCallBack}
                tagBoxChanged={this.setTagBoxValue}
                onTagBoxChanges={this.onSelectUserIDCallBack}
                onValueChange={this.onValueChange}
                ref={(ref) => (this.childHeader = ref)}
              />
            </div>
          </Item>

          <Item colSpan={8}>
            <div className="dx-fieldset">
              <div className="dx-field">
                <div className="dx-field-value">
                  <DataGridDefault
                    allowDisplayColumnChooser={
                      this.state.allowDisplayColumnChooser
                    }
                    allowExportGrid={this.state.allowExportGrid}
                    allowedPageSizes={DefaultPager.allowedPageSizes_listing}
                    allowRestoreLayout={this.state.allowRestoreLayout}
                    allowSaveGridLayout={this.state.allowSaveLayout}
                    className="dx-datagrid-items"
                    dataGridRef={this.dataGridRef}
                    dataSource={this.state.auditLogSetting}
                    defaultPageSize={DefaultPager.defaultPageSize_listing}
                    defaultSMI={AUDIT_LOG_DEFAULT_SMI}
                    focusedRowEnabled={true}
                    keyExpr="UniqueId"
                    onContentReady={this.onContentReady}
                    onCellPrepared={this.onCellPrepared}
                    onOptionChanged={this.onOptionChanged}
                    preferedLayout={this.state.preferedLayout}
                    shouldResetSavedLayout={this.shouldResetSavedLayout}
                    showMsgHandler={this.showMsgHandler}
                    noDataText={this.state.noDataText}
                  >
                    <Column
                      name="auditLogLogDatetime_v1"
                      dataField={'LogDatetime'}
                      caption={formatMessage('LogDateTime')}
                      width={200}
                      cellRender={customSearch({
                        allowSearch: true,
                        searchText: this.state.searchText,
                      })}
                      hasCustomSearch={true}
                    />

                    <Column
                      name="auditLogCode"
                      dataField={'Code'}
                      caption={formatMessage('Code')}
                      minWidth={60}
                      cellRender={customSearch({
                        allowSearch: true,
                        searchText: this.state.searchText,
                      })}
                      hasCustomSearch={true}
                    />

                    <Column
                      name="auditLogEventType"
                      dataField={'EventType'}
                      caption={formatMessage('EventType')}
                      minWidth={60}
                      cellRender={customSearch({
                        allowSearch: true,
                        searchText: this.state.searchText,
                      })}
                      hasCustomSearch={true}
                    />

                    <Column
                      name="auditLogColumnName"
                      dataField={'ColumnName'}
                      caption={formatMessage('ColumnName')}
                      minWidth={60}
                      cellRender={customSearch({
                        allowSearch: true,
                        searchText: this.state.searchText,
                      })}
                      hasCustomSearch={true}
                    />

                    <Column
                      name="auditLogDescription"
                      dataField={'Description'}
                      caption={formatMessage('Description')}
                      minWidth={60}
                      cellRender={customSearch({
                        allowSearch: true,
                        searchText: this.state.searchText,
                      })}
                      hasCustomSearch={true}
                    />

                    <Column
                      name="auditLogUserID"
                      dataField={'UserID'}
                      caption={formatMessage('UserID')}
                      minWidth={60}
                      cellRender={customSearch({
                        allowSearch: true,
                        searchText: this.state.searchText,
                      })}
                      hasCustomSearch={true}
                    />

                    <Summary>
                      <TotalItem
                        name="totalCount"
                        summaryType="count"
                        displayFormat="Rec: {0}"
                        showInColumn="LogDatetime"
                      />
                    </Summary>
                  </DataGridDefault>
                </div>
              </div>
            </div>
          </Item>
        </Form>
      </React.Fragment>
    )
  }
}

export default AuditLog
